// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13hVq","index":"styles_index__3pywh"};